module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_ii"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fmt"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("By the same author")])]), _vm._v(" "), _c('p', {
    staticClass: "fm"
  }, [_vm._v("Non-fiction")]), _vm._v(" "), _c('p', {
    staticClass: "fm1"
  }, [_vm._v("The Hundredth Year")]), _vm._v(" "), _c('p', {
    staticClass: "fm1"
  }, [_vm._v("The Audit Report")]), _vm._v(" "), _c('p', {
    staticClass: "fm1"
  }, [_vm._v("The Landlord’s Handbook")]), _vm._v(" "), _c('p', {
    staticClass: "fm"
  }, [_vm._v("Fiction")]), _vm._v(" "), _c('p', {
    staticClass: "fm1"
  }, [_vm._v("There’s only one Henry Green")]), _vm._v(" "), _c('p', {
    staticClass: "fm"
  }, [_vm._v("As translator")]), _vm._v(" "), _c('p', {
    staticClass: "fm1"
  }, [_vm._v("An Armenian Family Torn Apart")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d71eb6f4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/02_Author.vue
// module id = 60
// module chunks = 0